import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const InlineImage: LoadableType<any> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-InlineImage" */ './InlineImage.tsx')).InlineImage,
});
